import gql from 'graphql-tag';

export default gql`
query getFathomData($obj: GetFathomDataInput!) {
  getFathomData(object: $obj) {
    result
  }
}
`;
